import { Box, Button, CircularProgress, Dialog, FormControlLabel, makeStyles, TextField } from "@material-ui/core";
import { useState } from "react";
import { DetailsMode } from "../DetailsDialog";
import DateInputField, { getCurrentDate } from "../ui/DateInputField";
import TextInputField from "../ui/TextInputField";
import { PriceList } from "../../api/PriceListApi";
import useHttp from "../../security/Http.hook";

interface Properties {
  open: boolean;
  mode: DetailsMode;
  priceList?: PriceList|null;
  onPriceListMutated: () => void;
  onCancel: () => void;
}

const useStyles = makeStyles(theme => ({
  inputControl: {
    marginRight: 0
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3)
  },
  button: {
    marginTop: theme.spacing(1)
  },
  label: {
    width: 200,
    margin: theme.spacing(1)
  },
  priceChangeInput: {
    width: 100
  }
}));

const PriceListDialog = (properties: Properties) => {
  const classes = useStyles();
  const http = useHttp();
  const mode = properties.mode;
  const priceList = properties.priceList;
  const priceListId = priceList?.id;
  const [name, setName] = useState<string>();
  const [startDate, setStartDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();
  const [processingMutation, setProcessingMutation] = useState<boolean>(false);
  
  const handlePricingChangeSaveButtonClicked = () => {
    if (name === undefined) {
      console.debug(`Price list name not provided`);
    } else {
      setProcessingMutation(true);
      const priceList = {
        name,
        startDate,
        endDate
      };
      if (mode === DetailsMode.Create) {
        http
          .post('api/price-lists', priceList)
          .then(() => {
            setProcessingMutation(false);
            properties.onPriceListMutated();
          });
      } else if (mode === DetailsMode.Update) {
        http
          .put(`api/price-lists/${priceListId}`, priceList)
          .then(() => {
            setProcessingMutation(false);
            properties.onPriceListMutated();
          });
      }
    }
  };

  return (
    <Dialog open={properties.open}>
      <Box className={classes.dialogContent}>
        <TextInputField
          label='Nazwa'
          autoFocus
          initialValue={ mode === DetailsMode.Update ? priceList?.name : name }
          errorMessage={ name => !name ? "Nazwa jest wymagana" : null }
          onValueChange={ setName }
        />
        <DateInputField
          initialValue={ mode === DetailsMode.Update ? priceList?.startDate : getCurrentDate() }
          label='Początek obowiązywania'
          onValueChange={ setStartDate }
        />
        <DateInputField
          initialValue={ mode === DetailsMode.Update ? priceList?.endDate : '' }
          label='Koniec obowiązywania'
          onValueChange={ setEndDate }
        />
        <Button
          color='primary'
          className={ classes.button }
          onClick={ handlePricingChangeSaveButtonClicked }
          variant='contained'>
            { processingMutation ? <CircularProgress color='secondary' size={ 24 } /> : 'Zapisz i zamknij' }
        </Button>
        <Button
          color='secondary'
          className={ classes.button }
          onClick={ properties.onCancel }
          variant='contained'>
            Anuluj wprowadzanie
        </Button>
      </Box>
    </Dialog>
  );
};

export default PriceListDialog;